// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.k-grid td {
    white-space: nowrap;
    text-overflow: ellipsis;
}

/*grid header multiline*/
.k-grid-header th.k-header 
{
    vertical-align:middle !important;
}

    .k-grid th.k-header .k-link, .k-grid .k-grid-header-locked .k-header .k-link {
        overflow: initial !important;
    }

.k-grid .k-column-title {
    white-space: normal !important;
    text-overflow:initial !important;
}

.k-grid-content tr.k-selected {
    background-color: #428bca !important;
}
/*---*/`, "",{"version":3,"sources":["webpack://./App/Web/Styles/KendoUI.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,wBAAwB;AACxB;;IAEI,gCAAgC;AACpC;;IAEI;QACI,4BAA4B;IAChC;;AAEJ;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;AACA,MAAM","sourcesContent":["\n.k-grid td {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n/*grid header multiline*/\n.k-grid-header th.k-header \n{\n    vertical-align:middle !important;\n}\n\n    .k-grid th.k-header .k-link, .k-grid .k-grid-header-locked .k-header .k-link {\n        overflow: initial !important;\n    }\n\n.k-grid .k-column-title {\n    white-space: normal !important;\n    text-overflow:initial !important;\n}\n\n.k-grid-content tr.k-selected {\n    background-color: #428bca !important;\n}\n/*---*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
